<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-energy`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.08 4.315a3 3 0 012.328.01l17.769 7.576A3 3 0 0145 14.661v19.645a3 3 0 01-1.951 2.81L25.28 43.745a3 3 0 01-2.074.008L4.974 37.12A3 3 0 013 34.299V14.668a3 3 0 011.848-2.77l18.231-7.582zm1.146 3.855L7 15.334V33.6l17.227 6.27L41 33.61v-18.29L24.226 8.17zm3.498 17.623L21.608 18l-6.377 4.723h-6.19L9 26.37h7.367l4.376-3.051 6.34 7.68 6.307-4.63H39l-.02-3.647h-7.117l-4.139 3.07z"/></svg>
</template>
<script>

export default {
  name: 'IconEnergy',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
